import React from 'react'

const BlankPage = () => {
    return (
        <div className="min-h-screen flex flex-col justify-center items-center bg-gradient-to-br from-orange-50 to-orange-100">
            <div className="text-center px-6">
                <div className="mb-8">
                    <img src="/assets/pantria/web_logo.png" alt="Pantria" className="h-20 mx-auto mb-4" />
                </div>
                
                <h1 className="text-5xl md:text-6xl font-bold text-gray-800 mb-4">
                    Coming Soon
                </h1>
                
                <p className="text-xl md:text-2xl text-gray-600 mb-8 max-w-2xl mx-auto">
                    We're cooking up something amazing! Pantria will connect food lovers with local home cooks across the UK.
                </p>
                
                <div className="bg-white rounded-lg shadow-lg p-6 max-w-md mx-auto">
                    <h2 className="text-lg font-semibold text-gray-800 mb-2">
                        🚀 Stay Updated
                    </h2>
                    <p className="text-gray-600 text-sm">
                        We're putting the finishing touches on connecting amazing home cooks with food lovers like you.
                    </p>
                </div>
            </div>
        </div>
    )
}

export default BlankPage